import { assign, get, set } from 'lodash';

import { IEntity, ILocation, ISource, ISite, ISubnet } from '@nrwl/common-lib';

export class Site implements IEntity {
  isDeleted: boolean;
  sitesData: ISite;
  escapedName: string;

  constructor(dataIn: ISite) {
    this.escapedName = this.escapeString(dataIn.name);
    this.sitesData = {} as ISite;
    this.setSites(dataIn);
    this.isDeleted = get(this.sitesData, 'deleted', false);
  }

  //-------------------------------------------------Sites data-------------------------------------------------------
  getSites(): ISite {
    return this.sitesData;
  }

  getId(): string {
    return get(this.sitesData, 'id', null);
  }

  getDescription(): string {
    return this.sitesData.description || null;
  }

  getName(): string {
    return this.sitesData.name || null;
  }

  getLocation(): ILocation {
    return this.sitesData.location || null;
  }

  getLocationName(): string {
    return this.sitesData.locationname || null;
  }

  getSource(): ISource {
    return this.sitesData.source || null;
  }

  getSubnets(): Array<ISubnet> {
    return this.sitesData.subnets || null;
  }

  getTags(): string {
    return get(this.sitesData, 'tags', null);
  }

  getTagsNames(): string {
    return (this.sitesData.tags || []).join(', ');
  }

  isDefault(): boolean {
    return this.sitesData.isDefault || false;
  }

  isSiteDeleted(): boolean {
    return this.sitesData.deleted || false;
  }

  getEscapedName(): string {
    return this.escapedName;
  }

  escapeString(input: string): string {
    return JSON.stringify(input).replace(/^"(.*)"$/, '$1');
  }

  setId(id: number): string {
    return assign(this.sitesData, 'id', id);
  }

  setSites(dataIn: ISite): void {
    assign(this.sitesData, dataIn);
    this.escapedName = this.escapeString(this.sitesData.name);
  }

  setDescription(description: string): void {
    set(this.sitesData, 'description', description);
  }

  setLocation(location: ILocation): void {
    set(this.sitesData, 'location', location);
  }

  setLocationName(location: string): void {
    set(this.sitesData, 'locationname', location);
  }

  setName(name: string): void {
    set(this.sitesData, 'name', name);
  }

  setSource(source: ISource): void {
    set(this.sitesData, 'source', source);
  }

  setSubnets(subnets: Array<ISubnet>): void {
    set(this.sitesData, 'subnets', subnets);
  }

  setTags(tags: string): void {
    set(this.sitesData, 'tags', tags);
  }
}
